$.lui("part",".part_item_people",function (selector) {
    selector.on("click","[data-click]",function (e) {
        if($(e.originalEvent.originalTarget).is("a")) {
            return;
        }
        let el = $(this).closest(selector);
        el.toggleClass("state--toggled");
    })
});